<template>
  <div id="nearby-place" class="grid">
    <div class="grid-title">
      <h4>{{ $t("NEARBY_PLACE") }}</h4>
      <v-btn color="primary" class="pl-10 pr-10 v-btn-save" @click="save">{{
        $t("SAVE")
      }}</v-btn>
    </div>
    <div class="grid-body p-3 pb-0 border-top-unset">
      <v-form ref="form" v-model="valid">
        <v-row class="mt-0">
          <v-col sm="3">
            <v-select
              outlined
              dense
              :items="listLandMark"
              item-text="text"
              item-value="value"
              v-model="landMarkId"
              :label="$t('NEARBY_TYPE')"
              :rules="ruleNotEmpty"
            ></v-select>
          </v-col>
          <!-- :search-input.sync="search" -->
          <v-col sm="3">
            <v-autocomplete
              dense
              outlined
              no-filter
              :items="listArea"
              :loading="isLoading"
              item-text="text"
              item-value="value"
              v-model="areaId"
              :search-input.sync="search"
              hide-no-data
              hide-selected
              :label="$t('NEARBY_PLACE')"
              :rules="ruleNotEmpty"
            >
              <template v-slot:no-data>
                <div class="px-3 fs-12">{{ $t("NO_DATA") }}</div>
              </template>
            </v-autocomplete>
          </v-col>
          <v-col sm="2">
            <v-text-field
              v-model="distance"
              type="number"
              dense
              :rules="ruleNumber"
              outlined
              :label="$t('DISTANCE')"
              onkeydown="return event.keyCode !== 69 && event.keyCode !== 187 && event.keyCode !== 189"
            ></v-text-field>
          </v-col>
          <v-col sm="2">
            <v-select
              :items="unitList"
              item-text="text"
              item-value="value"
              outlined
              dense
              v-model="unit"
              :label="$t('UNIT')"
              :rules="ruleNotEmpty"
            >
            </v-select>
          </v-col>
          <v-col sm="2">
            <v-btn
              @click="addArea()"
              outlined
              depressed
              class="pl-4 pr-4"
              height="37"
              style="margin-top: 2px;"
            >
              <v-icon>add</v-icon>
              {{ $t("ADD_NEW") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <div v-for="(landmark, landIndex) in listLandMark" :key="landmark.id">
        <div class="pt-2 pb-2">
          <hr class="mt-0" />
          <label class="label-title">
            {{ landmark.text }}
          </label>
          <v-row>
            <v-col
              v-for="(area, index) in landmark.areas"
              md="4"
              class="pt-0 pb-0"
            >
              <v-alert icon="place" text type="info" class="pt-3 pb-3">
                <div class="d-flex justify-space-between align-center">
                  <span>{{ area.name }}</span>
                  <span
                    >{{ area.distance }} {{ area.unit }}
                    <v-icon
                      color="red"
                      @click="deleteArea(landmark.value, index)"
                      size="17"
                      style="margin-top: -3px;"
                      >delete</v-icon
                    ></span
                  >
                </div>
              </v-alert>
            </v-col>
          </v-row>
        </div>
      </div>
      <hr class="mt-0" />
      <div class="mr-3 pb-3 d-flex align-center" style="max-width: 350px">
        <label class="text-nowrap mr-2">{{
          $t("CHANNEL_APPLY")
        }}</label>
        <v-autocomplete dense outlined item-text="text" item-value="value" :items="listOtaConnectGlobal"
          v-model="selectedOTAGlobal" chips multiple style="width: 270px;" disabled>
          <template v-slot:selection="{ item, index }">
            <v-chip color="primary" v-bind="item.attrs" :input-value="item.selected" >
              <span>{{ item.text }}</span>
            </v-chip>
          </template>
        </v-autocomplete>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped></style>
<script>
import { service } from "@/_services/GeneralInfomation/area.service.js";
import { _alert } from "@/_helpers/function.js";

export default {
  components: {},
  created() {
    this.initialize();
  },
  mounted() {
    document
      .querySelector(".v-tab.v-tab--active")
      .classList.remove("v-tab--active");
    document
      .querySelector(".v-tab[tabIndex='3']")
      .classList.add("v-tab--active");
  },
  data() {
    return {
      unitList: ["km", "m"],
      listLandMark: [],
      landMarkId: null,
      distance: null,
      listArea: [],
      areaId: null,
      unit: "km",
      langSystem: this.$i18n.locale,
      isLoading: false,
      search: null,
      valid: true,
      ruleNotEmpty: [v => !!v || this.$t("NOT_EMPTY")],
      ruleNumber: [
        v => !!v || this.$t("NOT_EMPTY"),
        v => (!!v && v.length <= 10) || this.$t("MAX_LENGTH_10")
      ]
    };
  },
  watch: {
    search(keyword) {
      // Items have already been requested
      if (this.isLoading) return;
      this.isLoading = true;
      // Lazily load input items
      service
        .getNearBy(this.landMarkId, keyword)
        .then(res => {
          this.listArea = res.data.map(x => {
            return {
              value: x.id,
              text: x.i18ns.find(y => y.lang == this.defaultI18n).name
            };
          });
          this.listArea = this.listArea.filter(x => x.value && x.text);
        })
        .catch(err => {
          // console.log(err);
        })
        .finally(() => (this.isLoading = false));
    }
  },
  methods: {
    async initialize() {
      await service.getLandmark().then(res => {
        this.listLandMark = res.data.map(x => {
          return {
            value: x.id,
            text: x.i18ns.find(y => y.lang == this.defaultI18n).name,
            areas: []
          };
        });
        this.landMarkId = this.listLandMark[0].value;
      });
      await service.getArea().then(res => {
        this.listLandMark.forEach(x => {
          let landmarkId = x.value;
          res.data.forEach(y => {
            if (y.landmark && y.landmark.id == landmarkId) {
              let convert = {
                areaId: y.id,
                distance: y.distance,
                unit: y.unit,
                name: y.i18ns.find(z => z.lang == this.defaultI18n).name
              };
              x.areas.push(convert);
            }
          });
        });
      });
    },
    addArea() {
      this.$refs.form.validate();
      if (this.valid) {
        let name = this.listArea.find(x => x.value == this.areaId).text;
        // Nếu đã được add vào trước đó thì replace bằng data mới, nếu chưa dc add thì thêm vào mảng.
        if (
          this.listLandMark
            .find(x => x.value == this.landMarkId)
            .areas.filter(y => y.areaId == this.areaId).length > 0
        ) {
          this.listLandMark
            .find(x => x.value == this.landMarkId)
            .areas.find(y => {
              if (y.areaId == this.areaId) {
                y.areaId = this.areaId;
                y.distance = this.distance;
                y.unit = this.unit;
                y.name = name;
              }
            });
        } else {
          this.listLandMark
            .find(x => x.value == this.landMarkId)
            .areas.push({
              areaId: this.areaId,
              distance: this.distance,
              unit: this.unit,
              name: name
            });
        }

        this.areaId = "";
        this.distance = "";
        this.$refs.form.resetValidation();
      }
    },
    async save() {
      let body = [];
      this.listLandMark.forEach(x => {
        let landmarkId = x.value;
        let areas = [];
        x.areas.forEach(y => {
          let temp = {
            areaId: y.areaId,
            distance: y.distance,
            unit: y.unit
          };
          areas.push(temp);
        });
        if (areas.length > 0) {
          body.push({
            landMarkId: landmarkId,
            areas: areas
          });
        }
      });

      service.create(body).then(res => {
        if (res.responseCode == 0) {
          _alert(res, this.$t("UPDATE_SUCCESS"), true);
        }
      });
    },
    deleteArea(landMarkId, index) {
      this.listLandMark.forEach(x => {
        if (x.value == landMarkId) {
          x.areas.splice(index, 1);
        }
      });
    }
  }
};
</script>
